export default "__VITE_ASSET__VWab8hOb__"